module.exports = __webpack_public_path__ + "media/stylesheets/images/recruit_home_img-e1fdfedc27bbe040a4edf0be201efedb.jpg";